import { Injectable, signal, computed } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectData, ProjectDataService } from '../../../shared/models/project.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private projectData = signal<ProjectDataService | null>(null);

  // Computed properties
  hasProject = computed(() => !!this.projectData());
  currentProject = computed(() => this.projectData());

  constructor(private router: Router) {
    // Load project data from localStorage on service initialization
    this.loadProjectFromStorage();
  }

  // Methods
  setProject(project: ProjectDataService): void {
    this.projectData.set(project);
    this.saveProjectToStorage(project);
  }

  clearProject(): void {
    this.projectData.set(null);
    this.removeProjectFromStorage();
  }

  navigateToProjectInfo(): void {
    this.router.navigate(['/home/gestao-projeto/project-info']);
  }

  navigateToHome(): void {
    this.router.navigate(['/home']);
  }

  // Storage methods
  private saveProjectToStorage(project: ProjectData): void {
    try {
      localStorage.setItem('gemeo-project-data', JSON.stringify(project));
    } catch (error) {
      console.error('Erro ao salvar dados do projeto:', error);
    }
  }

  private loadProjectFromStorage(): void {
    try {
      const stored = localStorage.getItem('gemeo-project-data');
      if (stored) {
        const project = JSON.parse(stored) as ProjectData;
        this.projectData.set(project);
      }
    } catch (error) {
      console.error('Erro ao carregar dados do projeto:', error);
      this.removeProjectFromStorage();
    }
  }

  private removeProjectFromStorage(): void {
    try {
      localStorage.removeItem('gemeo-project-data');
    } catch (error) {
      console.error('Erro ao remover dados do projeto:', error);
    }
  }
}
